import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppInsights } from 'applicationinsights-js';
import { EventLoggerService } from './event-logger.service';

@Injectable()
export class EventLoggerServiceImpl implements EventLoggerService {

    constructor(private router: Router) { }
    logError(error: Error, message: string, data: any) {
        AppInsights.trackException(error, this.router.url, data, {}, 3);
    }
    logMessage(message: string, data: any) {
        AppInsights.trackTrace(message, { url: this.router.url, data: data });
    }

    logUserAction(message: string, data: any) {
        AppInsights.trackEvent(message, { url: this.router.url, data: data });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/event-logger-impl.service.ts